module.exports = __webpack_public_path__ + "img/busd.3d55f91c.svg";